import Axios from "axios";
import {
  SET_SALARY_PROCESS_LIST,
  UNSET_SALARY_PROCESS_LIST,
  SET_SALARY_PROCESS_DETAILS,
  UNSET_SALARY_PROCESS_DETAILS,
} from "@/store/mutation-types";
import {
  runSalaryProcess as runSalaryProcessApi,
  getSalaryProcessList as getSalaryProcessListApi,
  getSalaryProcessById as getSalaryProcessByIdApi,
} from "@/store/api";

const state = {
  salaryProcessList: [],
  salaryProcessDetails: null,
  loading: false, 
};

const getters = {
  salaryProcessList(state) {
    return state.salaryProcessList;
  },
  salaryProcessDetails(state) {
    return state.salaryProcessDetails;
  },
};

const mutations = {
  [SET_SALARY_PROCESS_LIST](state, data) {
    state.salaryProcessList = data;
  },
  [UNSET_SALARY_PROCESS_LIST](state) {
    state.salaryProcessList = [];
  },
  [SET_SALARY_PROCESS_DETAILS](state, data) {
    state.salaryProcessDetails = data;
  },
  [UNSET_SALARY_PROCESS_DETAILS](state) {
    state.salaryProcessDetails = null;
  },

  SET_LOADING(state) {
    state.loading = true;
  },
  UNSET_LOADING(state) {
    state.loading = false;
  },
};

const actions = {
  runSalaryProcess({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(runSalaryProcessApi, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalaryProcessList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getSalaryProcessListApi}`, { params: data })
        .then((response) => {
          commit(SET_SALARY_PROCESS_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_SALARY_PROCESS_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalaryProcessById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getSalaryProcessByIdApi}/${id}`)
        .then((response) => {
          commit(SET_SALARY_PROCESS_DETAILS, response.data.data || null);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_SALARY_PROCESS_DETAILS);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

